import { courseLineGenerator } from './courseLineGenerator';
import { CourseModule } from '@/models/CourseModule';

export function moduleGenerator(module?: Partial<CourseModule>): CourseModule {
  return {
    id: 1,
    name: 'Módulo 1',
    description: 'Descrição do módulo',
    courseLineId: 1,
    courseLine: courseLineGenerator(module?.courseLine),
    bannerImg: null,
    order: 1,
    ...module,
  };
}
